<template>
    <div class="main-bd mg20 pro-visible">
        <el-row class="searchSection">
            <el-form ref="form" :inline="true" :model="searcherModel" class="demo-form-inline"
                     :key="$router.currentRoute.path">
                <el-form-item label="发票抬头">
                    <el-input size="small" placeholder="请输入发票抬头" v-model="searcherModel.title"></el-input>
                </el-form-item>
                <el-form-item label="客户名称">
                    <CustomerSelect ref="customer" v-model="searcherModel.customer_name"
                                    @change="CustomerHandleChange"></CustomerSelect>
                </el-form-item>
                <el-form-item label="订单负责人" v-if="$route.path=='/order/invoice'">
                    <UserSelect ref="user" v-model="searcherModel.main_sale" @change="UserHandleChange"></UserSelect>
                </el-form-item>
                <el-form-item label="所属部门">
                    <UserCascader ref="UserCascader" v-model="searcherModel.branch_id" :isBusiness="true" @change="changeBranch"></UserCascader>
                </el-form-item>
                <el-form-item label="订单ID">
                    <el-input size="small" placeholder="订单ID" v-model="searcherModel.order_id"></el-input>
                </el-form-item>
                <el-form-item label="开票状态">
                    <el-select size="small" v-model="searcherModel.issue" placeholder="请选择">
                        <el-option v-for="(item, key) in invoice_issue" :label="item.label"
                                   :value="item.value" :key="key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否作废">
                    <el-select size="small" v-model="searcherModel.is_delete" placeholder="请选择">
                        <el-option v-for="(item, key) in invoice_status" :label="item.label"
                                   :value="item.value" :key="key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开票日期">
                    <el-date-picker
                            size="small"
                            type="daterange"
                            unlink-panels
                            v-model="searcherModel.time"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="创建时间">
                    <el-date-picker
                            size="small"
                            type="daterange"
                            unlink-panels
                            v-model="searcherModel.apply_time"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="申请开票时间">
                    <el-date-picker
                            size="small"
                            type="daterange"
                            unlink-panels
                            v-model="searcherModel.apply_open_at"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                  <el-form-item label="发票编号">
                       <el-input size="small" placeholder="请输入发票编号" v-model="searcherModel.ids"></el-input>
                   </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" icon="el-icon-search" @click="submitSearch">搜索
                    </el-button>
                    <el-button size="small" @click="resetForm(true)">重置</el-button>
                </el-form-item>
            </el-form>
        </el-row>
        <el-row class="addBtn">
            <el-button type="primary" size="small" @click="add()" >新增发票</el-button>
            <el-button type="primary" size="small" v-if="Acs('/order/issue')" @click="batchOpen" >确认开票</el-button>
            <ExportFile 
              v-if="Acs('/order/export-invoice')"
              :url="'/api/export/invoice'" 
              :params="searcherModel" 
              filename="发票信息" 
              buttonName="导出Excel">
            </ExportFile>
            <!-- <el-button type="primary" size="small"  v-if="Acs('/order/export-invoice')" @click="exportInvoice">导出</el-button> -->
            <span v-if="$route.path=='/order/invoice'">
            <el-button type="primary" size="small"  v-if="Acs('/order/create-invoice-centext')"  @click="newOpenInvoiceContext">新增开票内容</el-button>
            </span>
        </el-row>
        <el-row>
            <el-table :data="list" border style="width: 100%"  @selection-change="handleSelectionChange" :key="$route.path" v-loading="loading">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column prop="id" label="发票编号"></el-table-column>
                <el-table-column prop="title" label="发票抬头"></el-table-column>
                <el-table-column prop="input_at" label="发票开具日期"></el-table-column>
                <el-table-column prop="apply_open_at" label="申请开票日期"></el-table-column>
                <el-table-column prop="total_amount" label="开票金额"></el-table-column>
                <el-table-column prop="type_memo" label="发票类型"></el-table-column>
                <el-table-column prop="sale_man" label="订单负责人"></el-table-column>
                <el-table-column label="待开票金额">
                    <template slot-scope="scope">
                        <span>{{scope.row.wait_invoice_amount}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="order_total_amount" label="合同金额"></el-table-column>
                <el-table-column prop="customer_name" label="对应客户">
                    <template slot-scope="scope">
                        <a v-if="Acs('/customers/view')" style="color: #1890ff" @click="toCustomer(scope.row)">{{scope.row.customer_name}}</a>
                        <a style="color: #1890ff" v-else>{{scope.row.customer_name}}</a>
                    </template>
                </el-table-column>
                <el-table-column prop="order_id" label="对应订单ID">
                    <template slot-scope="scope">
                        <a style="color: #1890ff" @click="toOrder(scope.row)">{{scope.row.order_id}}</a>
                    </template>
                </el-table-column>
                <el-table-column prop="issue_memo" label="开票状态"></el-table-column>
                <el-table-column prop="delete_memo" label="是否作废"></el-table-column>
                <el-table-column prop="address" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" v-if="!scope.row.is_delete &&　Acs('/order/issue')" @click="edit(scope.row)" size="small">编辑</el-button>
                        <el-button type="text" @click="show(scope.row)" size="small">查看</el-button>
<!--                        <el-button type="text" v-if="!scope.row.issue && Acs('/order/issue')" @click="open(scope.row)" size="small">开票</el-button>-->
                        <el-button type="text" v-if="!scope.row.is_delete && Acs('/order/delete-invoice')" @click="drop(scope.row)" size="small">{{ scope.row.issue == 1 ? '作废' : '删除' }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row v-if="linkPage">
            <pagination :linkPage="linkPage"></pagination>
        </el-row>
        <!--新增发票表单-->
        <invoice-table v-if="dialogInvoiceVisible" :is_edit="is_edit" :invoice-form="form" :is_show="is_show" @handleAddInvoice="fillInvoice" is_need_order_id="true"></invoice-table>
        <!--新增开发票内容表单-->
        <template>
          <el-dialog v-if="is_invoice_show" title="新增开票内容" :visible="true"  width="700px" center @close="closeDialog" >
            <el-input size="small"  v-model="input_invoice" placeholder="请输入新增开票内容名称" style="width: 300px;margin-bottom: 10px" ></el-input>
            <el-button type="primary" size="small"  @click="addInvoiceContext" >添加</el-button>
          <el-table
              :data="OpenInvinceData"
              height="400"
              :header-cell-style="{textAlign: 'center'}"
              center
              border
              style="width: 800px;">
            <el-table-column
                prop="value"
                label="开票内容ID"
                width="180">
            </el-table-column>
            <el-table-column
                prop="label"
                label="开票内容">
            </el-table-column>
          </el-table>
          </el-dialog>
        </template>

    </div>
</template>

<script>
    import UserSelect from "~/widgets/UserSelect.vue";
    import CustomerSelect from "~/widgets/CustomerSelect.vue";
    import Pagination from "~/widgets/Pagination.vue";
    import OrderService from "~/services/order";
    import InvoiceTable from "~/views/order/invoiceTable.vue";
    import UserCascader from "~/widgets/UserCascader.vue";
    import ExportFile from "~/widgets/ExportFile.vue";
    export default {
        name: "invoice",
        components: {
            UserSelect,
            CustomerSelect,
            InvoiceTable,
            Pagination,
            UserCascader,
            ExportFile
        },
        data() {
            return {
                OpenInvinceData:[],
                list: [],
                input_invoice:'',
                loading: true,
                is_edit:false,
                is_show:false,
                is_invoice_show:false,
                linkPage: null,
                dialogInvoiceVisible:'',
                multipleInvoice:'',
                form:{},
                searcherModel: {
                    apply_time:'',
                    apply_open_at: [],
                    time: '',
                    type: '',
                    customer_name: '',
                    main_sale: '',
                    title: '',
                    order_id: '',
                    is_delete: '',
                    issue: '',
                    user_id:'',
                    branch_id: '',
                    path: this.$route.path,
                    ids:''
                },
                invoice_status: [
                    {
                        value: 2,
                        label: '全部'
                    }, {
                        value: 0,
                        label: '否'
                    }, {
                        value: 1,
                        label: '是'
                    }
                ],
                invoice_issue: [
                    {
                        value: 2,
                        label: '全部'
                    }, {
                        value: 0,
                        label: '未开票'
                    }, {
                        value: 1,
                        label: '已开票'
                    }
                ],
            }
        },
        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function (to, from, next) {
            let params = this.searcherModel;
            params['page'] = to.query["page"];
            params['perPage'] = to.query["perPage"];
            this.getList(params);
        },
        created() {
            this.getList(this.searcherModel);
          //获取开发票内容
          var context = OrderService.myInvoiceContext();
          context.then(res => {
            this.OpenInvinceData = res.data;
          });
        },
        watch:{
            $route(to, from) {
                this.resetForm();
                let params = this.searcherModel;
                console.log(this.searcherModel);
                params['page'] = to.query["page"];
                params['perPage'] = to.query["perPage"];
                this.getList(params);
            },
        },
        methods: {
            toCustomer(row) {
                let path = "/customers/view";
                let data = this.$router.resolve({
                    url:"/customers/view",
                    name:"/order/view",
                    path: path,
                    query: {
                        id:row.customer_id
                    }
                });
                window.open(data.href, '_blank');
            },
            newOpenInvoiceContext() {
              this.is_invoice_show = true;//新增开发票内容显示
            },
            closeDialog(){
              this.is_invoice_show=false//新增开发票内容显示
            },
            //添加开票内容方法
            addInvoiceContext() {
              if(! this.input_invoice){
                this.$message({
                  type: 'error',
                  message: '请输入开票内容名称!'
                });
                return false;
              }

              OrderService.addNewInvoiceContext({'label': this.input_invoice}).then(res => {
                if (res.code == 0) {
                  this.$message({
                    type: 'success',
                    message: '操作成功!',
                  });
                  this.OpenInvinceData = res.data
                }
              })
            },
            toOrder(row) {
                let path = "/order/view";
                let data = this.$router.resolve({
                    url:"/order/view",
                    name:"/order/view",
                    path: path,
                    query: {
                        id:row.order_id
                    }
                });
                window.open(data.href, '_blank');
            },
            exportInvoice(){
                const params = [];
                if(this.$route.path=='/order/my-invoice'){
                    this.searcherModel.user_id =  this.$store.getters.userId;
                }
                let obj = this.searcherModel;
                let filter_key = ['time','apply_time','apply_open_at'];
                Object.keys(obj).forEach((key) => {
                    if (filter_key.includes(key) && obj[key].length > 0) {
                        let new_key = key + '[]';
                        let value1 = new Date(obj[key][0]).toLocaleDateString();
                        let value2 = new Date(obj[key][1]).toLocaleDateString();
                        params.push([new_key, encodeURIComponent(value1)].join('='));
                        params.push([new_key, encodeURIComponent(value2)].join('='));
                        return;
                    }
                    let value = obj[key];
                    params.push([key, encodeURIComponent(value)].join('='))
                })
                let str = params.join('&');
                let url = 'api/order/export-invoice?access-token=' + this.$store.getters.token + '&';
                let elemIF = document.createElement("iframe");
                elemIF.width = 0;
                elemIF.height = 0;
                elemIF.src = url + str;
                elemIF.style.display = "none";
                document.body.appendChild(elemIF);
            },
            handleSelectionChange(val) {
                this.multipleInvoice = _.mapValues(val,'id');
            },
            batchOpen(){
                if(!this.multipleInvoice){
                    this.$message({
                        type: 'error',
                        message: '请选择需要开具的发票!'
                    });
                    return false;
                }
                this.$confirm('确定批量开票?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'info'
                }).then(() => {
                    OrderService.issue({'batch':this.multipleInvoice}).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '开具成功!'
                            });
                            this.getList(this.searcherModel);
                            this.multipleInvoice = '';
                        }
                    })
                })
            },
            add(){
                this.form = {};
                this.is_edit = false;
                this.dialogInvoiceVisible = true;
            },
            edit(form){
                this.form = form;
                this.is_edit = true;
                this.dialogInvoiceVisible = true;
            },
            open(form){
                this.$confirm('请核对好订单信息和发票信息后在进行发票的开具?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'info'
                }).then(() => {
                    OrderService.issue(form).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '开具成功!'
                            });
                            this.getList(this.searcherModel);
                        }
                    })
                })
            },
            show(form){
                this.form = form;
                this.is_show = true;
                this.dialogInvoiceVisible = true;
            },
            drop(form){
              let confirm_str = form.issue === 1 ? '作废' : '删除';
                this.$confirm('你确认要' + confirm_str + '这笔发票吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'info'
                }).then(() => {
                    OrderService.deleteInvoice({ids: [form.id]}).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '作废成功!'
                            });
                            this.getList(this.searcherModel);
                        }
                    })
                })
            },
            fillInvoice(form) {
                this.is_show = false
                this.form = {};
                if (form) {
                    if(this.is_edit){
                        OrderService.editInvoice(form).then(res => {
                            if (res.code == 0) {
                                this.$message({
                                    type: 'success',
                                    message: '修改成功'
                                });
                                this.dialogInvoiceVisible = false;
                            }
                        });
                        this.is_edit = false;
                        this.getList(this.searcherModel);
                        return true;
                    }
                    OrderService.fillInvoice(form).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                type: 'success',
                                message: '发票填写成功，等待审核!'
                            });
                            this.dialogInvoiceVisible = false;
                        }
                    });
                } else {
                    this.dialogInvoiceVisible = false;
                }
            },
            resetForm(is_searcher=false) {
                this.searcherModel = {
                    apply_time:'',
                    apply_open_at: [],
                    time: '',
                    type: '',
                    customer_name: '',
                    main_sale: '',
                    title: '',
                    order_id: '',
                    is_delete: '',
                    issue: '',
                    user_id:'',
                    branch_id: '',
                    path: this.$route.path
                };
                if( this.$refs['user']){
                    this.$refs['user'].reset();
                }
                this.$refs['customer'].reset();
                this.$refs["UserCascader"].reset();
                if(is_searcher){
                    this.getList({});
                }
            },
            submitSearch() {
                this.getList(this.searcherModel);
            },
            getList(params = {}) {
                this.loading = true;
                let invoice =  '';
                if(this.$route.path=='/order/my-invoice'){
                    invoice = OrderService.myInvoice(params);
                }else{
                    invoice = OrderService.invoice(params)
                }
                invoice.then(res => {
                    this.loading = false;
                    this.list = res.data;
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                });
            },
            //业务员姓名远程搜索组件赋值
            UserHandleChange(object) {
                this.searcherModel.main_sale = object.value;
            },
            //客户名称远程搜索组件赋值
            CustomerHandleChange(object) {
                this.searcherModel.customer_name = object.value;
            },

            changeBranch(value) {
                if (value.length > 0) {
                    // 取得最后一级部门作为所属部门
                    this.searcherModel.branch_id = value[value.length - 1];
                } else {
                    this.searcherModel.branch_id = "";
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/order/invoice.vue